__turbopack_context__.v({
  "divider": "_5ozi9G_divider",
  "eyebrow": "_5ozi9G_eyebrow",
  "grid": "_5ozi9G_grid",
  "headingWrap": "_5ozi9G_headingWrap",
  "icon": "_5ozi9G_icon",
  "item": "_5ozi9G_item",
  "itemBody": "_5ozi9G_itemBody",
  "itemTitle": "_5ozi9G_itemTitle",
  "list": "_5ozi9G_list",
  "section": "_5ozi9G_section",
  "subtitle": "_5ozi9G_subtitle",
});
